module.exports = __webpack_public_path__ + "img/arrow_straight1.0a3fdf80.svg";